import { handleUrl, myHeadersWithTokenContentType } from '../global';
import { GetCompletionProps } from './types';

export const getCompletion = (osId: number): Promise<GetCompletionProps> => {
  const requestOptions = {
    method: 'GET',
    headers: myHeadersWithTokenContentType(),
  };
  const BaseUrl = handleUrl();
  return fetch(
    `${BaseUrl}/api/V1/work-orders/${osId}/property-characteristics/completion`,
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => JSON.parse(result))
    .catch((error) => new Error(error));
};
